import { ComputedRef } from 'vue'

import { Course } from '@/domain/entities/problem/course'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { CourseStatisticsViewModel } from '@/presentation/viewmodels/problem/courseStatisticsViewModel'

export class CourseStatisticsPresenter {
  private viewModel: CourseStatisticsViewModel

  constructor(viewModel: CourseStatisticsViewModel) {
    this.viewModel = viewModel
  }

  get courseStatisticsList(): ComputedRef<{ [programLanguage: string]: Course }> {
    return this.viewModel.courseStatisticsList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getCourseStatisticsListByLanguage(
    courseName: string,
    userId: string,
    programLanguage: ProgramLanguageType
  ): Promise<Course | undefined> {
    return await this.viewModel.getCourseStatisticsListByLanguage(courseName, userId, programLanguage)
  }

  clearCourseStatisticsList(): void {
    this.viewModel.clearCourseStatisticsList()
  }
}
